import { defineMessages } from 'react-intl';

const messages = defineMessages({
  returnToSender: {
    description: 'customsNonDelivery.returnToSender',
    defaultMessage: 'Return To Sender',
    id: 'qmVnYw',
  },
  treatAsAbandoned: {
    description: 'customsNonDelivery.treatAsAbandoned',
    defaultMessage: 'Treat As Abandoned',
    id: 'rPm4bF',
  },
});

export const CustomsNonDelivery = {
  Return: {
    name: 'Return',
    translation: messages.returnToSender,
  },
  Abandon: {
    name: 'Abandon',
    translation: messages.treatAsAbandoned,
  },
};
